<template>
  <v-container
    class="mb-7"
  >
    <v-row
      v-for="(project, index) in projects"
      :key="index"
      :cols="12"
      :class="{'flex-row-reverse': index % 2 !== 1}"
    >
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          :title="project.name"
        >
          <v-card-text>
            <span v-html="project.description" class="description"></span>
          </v-card-text>
          <v-card-actions>
            <v-chip
              v-for="tech in project.technologies"
              :key="tech"
              color="primary"
              class="mr-2"
            >
              {{ tech }}
            </v-chip>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <GalleryComponent :gallery="project.gallery "/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import GalleryComponent from '@/components/Gallery'

export default {
  name: 'CurrentProjectsView',
  components: { GalleryComponent },
  data () {
    return {
      projects: [
        {
          name: 'Rap Lyrics Analyzer',
          description: '<p>A website that analyzes rap lyrics.</p><p>The goal is to find an artist with the largest vocabulary ' +
              'and analyze lyrics from a qualitative point of view.</p><p>Inspired by <a ' +
            'href="https://pudding.cool/projects/vocabulary/index.html" target="_blank">this website</a>.</p>',
          technologies: ['Vue.js', 'Flask', 'Vuetify', 'Python', 'bs4', 'nltk', 'GraphQL'],
          gallery: [
            {
              image: '/rap/info.png',
              caption: 'Artist info component'
            },
            {
              image: '/rap/albums.png',
              caption: 'List of all studio albums by an artist'
            },
            {
              image: '/rap/cloud.png',
              caption: 'Word cloud showing 20 most used words by an artist'
            },
            {
              image: '/rap/words.png',
              caption: 'Table showing all words used by an artist and their frequency'
            }
          ]
        },
        {
          name: 'GeoTips',
          description: '<p>A website with tips/tricks for beginner Geoguessr players.</p>',
          technologies: ['Vue.js', 'Flask', 'Vuetify'],
          gallery: [
            {
              image: '/geotips/geoguessr_main.jpg',
              caption: ''
            }
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
